import { render, staticRenderFns } from "./ModalCourrierFluxPaillettes.vue?vue&type=template&id=8c4ecb74&"
import script from "./ModalCourrierFluxPaillettes.vue?vue&type=script&lang=js&"
export * from "./ModalCourrierFluxPaillettes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports